module.exports = __webpack_public_path__ + "static/media/Calvin Coolidge (I) - 1924.0fd2eec8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Calvin Coolidge (I) - 1924.jpg
// module id = 446
// module chunks = 0